class CosiPopupNewsletter extends HTMLElement {
  constructor() {
    super();
    this.storageKey = 'cosi-popup-newsletter';
  }

  connectedCallback() {
    // Remove o display:none inline do HTML para o CSS controlar a visibilidade
    // (evita flash/piscada antes do CSS carregar)
    this.style.removeProperty('display');

    this.delay = (parseInt(this.dataset.delay, 10) || 5) * 1000;
    this.dismissDays = parseInt(this.dataset.dismissDays, 10) || 7;
    this.mode = this.dataset.mode || 'simple';
    this.successDuration = this.dataset.successDuration || 'manual';

    this.screens = this.querySelectorAll('[data-screen]');
    this.overlay = this.querySelector('.cosi-popup__overlay');
    this.closeBtns = this.querySelectorAll('[data-action="close"]');
    this.primaryBtn = this.querySelector('[data-action="primary"]');
    this.backBtn = this.querySelector('[data-action="back"]');
    this.forms = this.querySelectorAll('form');
    this.couponBox = this.querySelector('.cosi-popup__coupon');
    this.copyFeedback = this.querySelector('.cosi-popup__copy-feedback');
    this.iframe = this.querySelector('iframe[name="cosi-popup-iframe"]');

    if (this.shouldShow()) {
      this.timer = setTimeout(() => this.open(), this.delay);
    }

    this.bindEvents();
  }

  shouldShow() {
    try {
      const raw = localStorage.getItem(this.storageKey);
      if (!raw) return true;
      const data = JSON.parse(raw);
      if (data.submitted) return false;
      if (data.dismissedAt) {
        const diffDays = (Date.now() - new Date(data.dismissedAt).getTime()) / (1000 * 60 * 60 * 24);
        return diffDays >= this.dismissDays;
      }
      return true;
    } catch (e) {
      return true;
    }
  }

  persist(submitted = false) {
    try {
      localStorage.setItem(this.storageKey, JSON.stringify({
        dismissedAt: new Date().toISOString(),
        submitted
      }));
    } catch (e) {}
  }

  open() {
    this.classList.add('is-visible');
    if (this.overlay) this.overlay.classList.add('is-visible');
    document.body.classList.add('cosi-popup--open');
    this.showScreen('offer');
  }

  close() {
    this.classList.remove('is-visible');
    if (this.overlay) this.overlay.classList.remove('is-visible');
    document.body.classList.remove('cosi-popup--open');
    // Limpa timer de auto-close ao fechar manualmente
    if (this.autoCloseTimer) {
      clearTimeout(this.autoCloseTimer);
      this.autoCloseTimer = null;
    }
  }

  showScreen(name) {
    this.screens.forEach(screen => {
      screen.classList.toggle('is-active', screen.dataset.screen === name);
    });

    // Re-trigger entrance animations
    const active = this.querySelector('[data-screen].is-active');
    if (active) {
      active.querySelectorAll('.cosi-popup__logo, .cosi-popup__title, .cosi-popup__subtitle, .cosi-popup__form, .cosi-popup__actions, .cosi-popup__success-icon, .cosi-popup__coupon, .cosi-popup__btn').forEach(el => {
        el.style.animation = 'none';
        el.offsetHeight;
        el.style.animation = '';
      });
    }
  }

  handleFormSubmit(event) {
    const form = event.target;
    const emailInput = form.querySelector('input[type="email"]');

    // Validação
    if (!emailInput?.value || !emailInput.checkValidity()) {
      emailInput?.reportValidity();
      event.preventDefault();
      return;
    }

    // Previne o submit nativo para controlar via iframe
    event.preventDefault();

    // Define o target do form para o iframe oculto
    if (this.iframe) {
      form.target = 'cosi-popup-iframe';
    }

    // Submete o form no iframe (sem recarregar a página)
    form.submit();

    // Mostra a tela de sucesso IMEDIATAMENTE — o usuário nunca perde o cupom
    this.onSubmitSuccess();
  }

  onSubmitSuccess() {
    this.persist(true);
    this.showScreen('success');

    // Auto-close configurável
    if (this.successDuration !== 'manual') {
      const seconds = parseInt(this.successDuration, 10);
      if (seconds > 0) {
        this.autoCloseTimer = setTimeout(() => {
          this.close();
        }, seconds * 1000);
      }
    }
  }

  copyCoupon() {
    const code = this.querySelector('.cosi-popup__coupon-code')?.textContent.trim();
    if (!code) return;

    const showFeedback = () => {
      this.copyFeedback?.classList.add('is-visible');
      setTimeout(() => this.copyFeedback?.classList.remove('is-visible'), 2000);
    };

    if (navigator.clipboard) {
      navigator.clipboard.writeText(code).then(showFeedback).catch(() => this.fallbackCopy(code, showFeedback));
    } else {
      this.fallbackCopy(code, showFeedback);
    }
  }

  fallbackCopy(text, callback) {
    const ta = document.createElement('textarea');
    ta.value = text;
    ta.style.cssText = 'position:fixed;top:-9999px;left:-9999px;opacity:0;';
    document.body.appendChild(ta);
    ta.select();
    try {
      document.execCommand('copy');
      callback();
    } catch (e) {}
    document.body.removeChild(ta);
  }

  bindEvents() {
    // Tecla ESC
    this._onKeydown = (e) => {
      if (e.key === 'Escape' && this.classList.contains('is-visible')) {
        this.persist();
        this.close();
      }
    };
    document.addEventListener('keydown', this._onKeydown);

    // Botões de fechar
    this.closeBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        this.persist();
        this.close();
      });
    });

    // Botão primário (multi-step)
    this.primaryBtn?.addEventListener('click', () => {
      if (this.mode === 'multistep') {
        this.showScreen('form');
      }
    });

    // Botão voltar (multi-step)
    this.backBtn?.addEventListener('click', () => this.showScreen('offer'));

    // Submit dos formulários
    this.forms.forEach(form => {
      form.addEventListener('submit', (e) => this.handleFormSubmit(e));
    });

    // Copiar cupom
    this.couponBox?.addEventListener('click', () => this.copyCoupon());

    // Fechar ao clicar no overlay
    this.overlay?.addEventListener('click', () => {
      this.persist();
      this.close();
    });
  }

  disconnectedCallback() {
    if (this.timer) clearTimeout(this.timer);
    if (this.autoCloseTimer) clearTimeout(this.autoCloseTimer);
    document.removeEventListener('keydown', this._onKeydown);
  }
}

customElements.define('cosi-popup-newsletter', CosiPopupNewsletter);
